/**
 * @desc
 * - A set of tabs that will slide to keep the active tab in the same location
 */
;(function () {
  angular.module('contrast.sliding-nav').directive('csSlidingNav', csSlidingNav)

  function csSlidingNav($, $log, $window) {
    'ngInject'

    var targetSelector = null,
      element = null

    return {
      restrict: 'A',
      scope: {
        csSlidingNav: '@'
      },
      link: link
    }

    function link(scope, elem, attrs) {
      targetSelector = attrs.csSlidingNav
      element = elem

      if (targetSelector) {
        element.append('<span class="sliding-nav-underline"></span>')

        scope.$watch(
          function () {
            return $(targetSelector).length
          },
          function (newVal, oldVal) {
            if (newVal != null && newVal != oldVal) {
              updatePositionIfNeeded()
            }
          }
        )

        scope.$watch(
          function () {
            var activeTab = element.find('li.active')

            return activeTab[0].textContent
          },
          function (newVal, oldVal) {
            if (newVal != null && newVal != oldVal) {
              updatePositionIfNeeded()
            }
          }
        )

        $window.addEventListener('resize', updatePositionIfNeeded)
      } else {
        $log.error('[csSlidingNav] No target element specified')
      }
    }

    function updatePositionIfNeeded() {
      var target = $(targetSelector),
        targetEl = null

      if (target && target.length > 0) {
        targetEl = target[0]
        if (target.length > 1) {
          for (var i = 0; i < target.length; i++) {
            if (target[i].offsetParent !== null) {
              targetEl = target[i]
              break
            }
          }
        }
      }

      if (element && targetEl) {
        updatePosition(element, targetEl)
      }
    }

    function updatePosition(element, targetEl) {
      var targetPos = getTargetPosition(targetEl),
        activeTabOffset = getActiveTabOffset(element),
        underlineEl = element.find('.sliding-nav-underline'),
        underlineOffset = getUnderlineOffset(underlineEl, activeTabOffset)

      element.css('left', targetPos + 'px')
      element.css('margin-left', '-' + activeTabOffset + 'px')
      underlineEl.css('left', underlineOffset + 'px')
    }

    function getTargetPosition(targetEl) {
      var rect = targetEl.getBoundingClientRect()

      return rect.left + rect.width / 2
    }

    function getActiveTabOffset(element) {
      var activeTab = element.find('li.active')

      if (activeTab) {
        var elemRect = element[0].getBoundingClientRect(),
          activeRect = activeTab[0].getBoundingClientRect()

        return activeRect.left - elemRect.left + activeRect.width / 2
      }
    }

    function getUnderlineOffset(el, offset) {
      var elRect = el[0].getBoundingClientRect()

      return offset - elRect.width / 2
    }
  }
})()
